"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelPendingConfirmation = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Button = _interopRequireDefault(require("../Button"));

var CancelPendingConfirmation = function CancelPendingConfirmation(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(Confirmation, (0, _extends2["default"])({
    title: t('premium.cancelPending.title'),
    subtitle: t('premium.cancelPending.subtitle'),
    confirm: t('button.confirm'),
    cancel: t('button.cancel')
  }, props));
};

exports.CancelPendingConfirmation = CancelPendingConfirmation;

var Confirmation = function Confirmation(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      confirm = _ref.confirm,
      cancel = _ref.cancel,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      isOpen = _ref.isOpen,
      toggle = _ref.toggle,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["title", "subtitle", "confirm", "cancel", "onConfirm", "onCancel", "isOpen", "toggle"]);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], (0, _extends2["default"])({
    open: isOpen,
    onClose: toggle
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-12"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "font-bold text-dark text-2xl text-center"
  }, title), subtitle && /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold text-dark mt-5 text-center"
  }, subtitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex mt-8"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    onClick: onCancel,
    className: "w-1/2 mr-3"
  }, cancel), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: onConfirm,
    className: "w-1/2 ml-3"
  }, confirm))));
};
//# sourceMappingURL=ChangePlanConfirmation.js.map